import { util } from 'echarts/core';
import { type ThemeParser } from '../../../core/theme';
import { overrideIfUndefined } from '../../../util/data';

/**
 * 交互
 */
export function parseAxisPointerInteract(option: Parameters<ThemeParser>[0]) {
  const interactOption = {
    dvHideDelay: 2e3,
    dvAutoHide: true,
    dvShowOnlyWhenRenderingContent: true,
    dvShowOutOfGrid: true,
    dvHideWhenClickInGrid: false
  };
  // eslint-disable-next-line no-param-reassign
  option.axisPointer = util.merge(interactOption, option.axisPointer, true);
}

export function axisPointerThemeParse(...args: Parameters<ThemeParser>): ReturnType<ThemeParser> {
  const option = args[0];

  option.axisPointer = overrideIfUndefined(option.axisPointer, {});

  parseAxisPointerInteract(option);
}
